import { DOCUMENT } from '@angular/common';
import { OnInit, Injectable, Inject, Renderer2, RendererFactory2, OnDestroy } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable()
export class ScriptLoader implements OnInit, OnDestroy {

    private renderer: Renderer2;
    private script: any;

    constructor(rendererFactory: RendererFactory2, @Inject(DOCUMENT) private _document) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    ngOnInit() {
        if (!environment.production) {
            this.tawkScript(false);
        } else {
            this.tawkScript(true);
        }

    }

    ngOnDestroy() {
        // remove tawkTo from page
        const iframes = document.querySelectorAll('iframe[title="chat widget"]');
        Array.prototype.forEach.call(iframes, function (node) {
            node.parentNode.removeChild(node);
        });
    }

    tawkScript(env: boolean) {
        if (!env) {
            // DEV
            // creates tawk script and loads it after Home
            const s = this.renderer.createElement('script');
            s.text = 'var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date()';
            (function () {
                const s1 = document.createElement('script'), s0 = document.getElementsByTagName('script')[0];
                s1.async = true;
                s1.id = 'tawkscript';
                s1.src = 'https://embed.tawk.to/598af5f21b1bed47ceb03bf3/default';
                s1.setAttribute('crossorigin', '*');
                s0.parentNode.insertBefore(s1, s0);
            })();
            this.script = s;
            this.renderer.appendChild(this._document.body, this.script);
        } else {
            // PRODUCTION
            // creates tawk script and loads it after Home
            const s = this.renderer.createElement('script');
            s.text = 'var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date()';
            (function () {
                const s1 = document.createElement('script'), s0 = document.getElementsByTagName('script')[0];
                s1.async = true;
                s1.id = 'tawkscript';
                s1.src = 'https://embed.tawk.to/580757851693680717ef5de9/default';
                s1.setAttribute('crossorigin', '*');
                s0.parentNode.insertBefore(s1, s0);
            })();
            this.script = s;
            this.renderer.appendChild(this._document.body, this.script);
        }
    }

}
